// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1YQ8m","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__11zuo"};